var React = require('react');

function Loader4 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_337)","key":0},[React.createElement("rect",{"width":"90","height":"16","fill":"white","key":0}),React.createElement("rect",{"y":"31.3333","width":"90","height":"16","fill":"white","key":1}),React.createElement("rect",{"y":"62.6667","width":"90","height":"16","fill":"white","key":2}),React.createElement("rect",{"y":"94","width":"90","height":"16","fill":"white","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_337"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader4.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader4;

Loader4.default = Loader4;
